<template>
    <main :class="{ 'user-message': true, 'internal-page': !isHomePage }"
        v-if="isHomePage && isUserLogged || !isHomePage && isUserLogged || !isHomePage && !isUserLogged"
        style="position: relative"
    >
        <img :src="staticData.img" :alt="staticData.imgAlt" :title="staticData.imgAlt"/>
        <section class="message-description" v-if="isUserLogged">
            <p class="user"><strong v-if="isHomePage">Hello, {{ user.name }}!</strong> Your rewards balance is:</p>
            <p class="points">{{ addCommasToNumber(user.points) }}</p>
            <p class="expired" v-if="!isHomePage && user.pointsToExpire >= 1">
                <span class="icon-exclamation-triangle"></span>
                {{ user.pointsToExpire }} points will expire on {{ formatDate(user.pointsExpirationDate) }}
            </p>
        </section>
        <section class="cta-description" v-if="isUserLogged && isHomePage">
            <p class="legend">{{ staticData.ctaText }}</p>
            <button class="" @click="ctaButonAction">{{ staticData.ctaButtonText }}</button>
            <p class="expired" v-if="user.pointsToExpire >= 1">
                <span class="icon-exclamation-triangle"></span>
                {{ user.pointsToExpire }} points will expire on {{ formatDate(user.pointsExpirationDate) }}
            </p>
        </section>

        <div id="modal-login" class="reveal modal-login reveal-modal" data-reveal data-close-on-click="false">
            <section>
                <h2>Please Verify your Account</h2>
                <button class="close-button" data-close type="button">
                    <span aria-hidden="true">×</span>
                </button>
                <div>
                    <div class="clear">
                        <p class="confirmationMessage">
                            We have updated security for Lottery360&deg;.
                            <br/>
                            <strong>
                                Please note that you will not be able to scan tickets or redeem existing points until you have completed the identity verification process.
                            </strong>
                        </p>
                    </div>
                    <div class="clear"></div>
                    <div class="modalFooter cf">
                        <a @click="handleID" class="ProcessPaymentButton button btn btn-primary">Verify my id</a>
                        <!-- <a href="#" class="cancelOrder" data-close>Cancel Purchase</a> -->
                    </div>
                </div>
            </section>
        </div>

        <AutoLogout></AutoLogout>
    </main>
</template>

<script>
import moment from 'moment';
import AutoLogout from './AutoLogout.vue';
import $ from 'jquery';
import Foundation from "@/foundation-sites/js/foundation.js";

export default {
    components:{
        AutoLogout
    },
    data: function () {
        return {
            isUserLogged: false,
            isHomePage: true,
            isDeleteAccountPage: false,
            user: {
                isUserLogged: false,
                id: '',
                name: '',
                points: '0',
                pointsToExpire: '0',
                pointsExpirationDate: ''
            },
            staticData: {
                img: '/site_images/my-lottery-360-white.png',
                imgAlt: 'My Lottery 360°',
                ctaText: 'Use your points to shop from our catalog for great gifts and gear. You’ve earned it!',
                ctaButtonText: 'Redeem Points',
                ctaUrl: '/prizes'
            }
        }
    },
    mounted: function () {
        // this.getUserPoints();
        this.getUserKYCStatus();
        this.getToken();

        let _this = this;
        (function (window, undefined) {
            'use strict';

            $('[data-reveal]').on('closed.zf.reveal', function () {
                var modal = $(this);
                // alert('closed');
                _this.reset();
            });

            $(document).foundation();
        })();

        // this.isDeleteAccountPage = window.location.pathname === '/my-profile/delete-your-account';
        this.isHomePage = window.location.pathname === '/' || window.location.pathname === '/home';
    },
    methods: {
        getToken() {
            this.isUserLogged = this.isUserAuthed();
            this.getAPItoken()
                .then((token) => {
                    this.token = token;
                    if (this.isUserLogged) {
                        this.getUser();
                    }
                })
                .then(() => {
                    this.getUserKYC();
                });
        },

        ctaButonAction() {
            window.location.href = this.staticData.ctaUrl;
        },
        addCommasToNumber(number) {
            const parts = number.toString().split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return parts.join('.');
        },
        formatDate(date) {
            const newDate = moment(date).format('MM/DD/YYYY');
            return newDate
        },
        openKYC() {
            let popup = new Foundation.Reveal($('#modal-login'));
            popup.open();
        },
        closeKYC() {
            $('#modal-login').hide();
            $('.reveal-overlay').hide();
        },
        handlePersonaData(personaData, inqId, status, email) {
            // console.log(this.step);
            // console.log('In handle');
            // console.log(personaData);
            // console.log("Troubleshooting Data");
            // console.log(inqId);
            // console.log(status);

            if (
                status === "completed" ||
                status === "approved" ||
                status === "passed"
            ) {
                //set the integral fields for BE first, in case issue with parameters from Persona
                this.summary = JSON.stringify(personaData);
                this.transactionID = inqId;
                this.verified = true;

                //prepopulate the fields

                this.userName = email;

                //check for then set first name
                if ("name-first" in personaData === true) {
                // console.log("First Name was returned.");
                this.firstName = personaData["name-first"].value;
                } else {
                console.log("First Name was not returned.");
                }

                //check for then set last name
                if ("name-last" in personaData === true) {
                // console.log("Last Name was returned");
                this.lastName = personaData["name-last"].value;
                } else {
                console.log("Last Name was not returned");
                }

                //process dob
                if ("birthdate" in personaData === true) {
                // console.log("Birthdate was returned");
                // this.date_birth = this.processDOB(personaData["birthdate"].value);
                this.date_birth = personaData["birthdate"].value;
                this.dateSelected();
                // console.log(this.date_birth);
                } else {
                console.log("Birthdate was not returned");
                }

                //process zip
                if ("address-postal-code" in personaData === true) {
                // console.log("Zip Code was returned");
                this.zipcode = this.processZip(
                    personaData["address-postal-code"].value,
                );
                } else {
                console.log("Zip Code not returned");
                }
                //process address street 1
                if ("address-street-1" in personaData === true) {
                // console.log("Address 1 Returned");
                this.mailingAddress = personaData["address-street-1"].value;
                } else {
                console.log("Address 1 Not Returned");
                }
                //process and check for address street 2
                if ("address-street-2" in personaData === true) {
                // console.log("Address 2 Returned");
                this.addressContinued = personaData["address-street-2"].value;
                } else {
                console.log("Address 2 Not Returned");
                }

                //is city returned
                if ("address-city" in personaData === true) {
                // console.log("City is returned");
                this.city = personaData["address-city"].value;
                } else {
                console.log("No City returned");
                }
                //is state returned
                if ("address-subdivision" in personaData === true) {
                // console.log("State is Returned");
                this.state = personaData["address-subdivision"].value;
                } else {
                console.log("No State Returned");
                }

                // this.country = personaData["address-country-code"].value;
                //need to handle this better for country code
                if (personaData["address-country-code"].value === "US") {
                this.country = "USA";
                }
            }

            if (status === "failed" || status === "declined") {
                this.step = 3;
            }
        },
        async getUserKYC() {
            // console.log("GEtting KYC")
            await this.getUserKYCStatus;
            let kycEvn = this.getENV('kyc');

            let kycAPI = this.$cookies.get('walkyc');

            if (kycAPI === null || kycAPI === undefined) {
                return false;
            } else  {
                if (kycAPI === "false" || kycEnv > 2) {
                    // Pop up the KYC MODAL
                    this.openKYC();
                    this.$cookies.remove('walkyc');
                }
            }
        },
        handleID() {
            this.launchPersonaEmbed(this.userName, this.handlePersonaData);
        },
        getUser: function () {

            let userData = JSON.parse( sessionStorage.getItem('apiToken'));
            let url = process.env.VUE_APP_APIURL + '/1.0/Ecommerce/GetUserAvailableCredit?userId=' + userData.user.userId, apiToken = this.token;
            fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + apiToken
                }
            }).then((response) => response.json()).then((json) => {
                
                let data = json.data;

                this.user.id = userData.user.userId;
                this.user.name = userData.user.firstName;
                this.user.points = data.pointBalance.balance;
                this.user.pointsToExpire = userData.user.pointBalance.pointsToExpire;
                this.user.pointsExpirationDate = userData.user.pointBalance.pointsExpirationDate;
            });
        }
    }
};
</script>